import { api } from "api/api";
import { NetworkError } from "api/networkError";
import { Teacher } from "types";
import { isValidResponse } from "utils/isValidResponse";

export const resetTeacherPassword = async (token: string, email: string, password: string): Promise<Teacher> => {
  const response = await api.post(
    `/admin/resetpassword`,
    { email: email, password: password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (response?.data && isValidResponse(response)) {
    return response?.data;
  } else {
    throw new NetworkError();
  }
};
